import { getApi } from '../../api';
import firebase from "firebase/app";
import firebaseAuth from "firebase/auth";

let SIGN_OUT = ({ state, commit }, firebaseId) => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      commit('SET_USER', null);
      commit('SET_FIREBASE_USER', null);
    })
    .catch(err => {

    });
};

let GET_USER_BY_FIREBASE_ID = ({ state, commit }, firebaseId) => {
  return new Promise((resolve, reject) => {
    getApi()
      .then(api => {
        api.get('users/firebase/' + firebaseId)
          .then(({ data }) => {
            commit('SET_USER', data.result);
            resolve();
          })
          .catch(err => {
            reject(err);
          })
      })
  });
};

export default {
  SIGN_OUT,
  GET_USER_BY_FIREBASE_ID
};


// WEBPACK FOOTER //
// ./src/store/user/actions.js